// pick item from object
export default function pick(obj, keys) {
    var clone = {};
    keys.forEach(function (key) {
        var k = key;
        if (key in obj) {
            clone[k] = obj[k];
        }
    });
    return clone;
}
export var NOOP = function () { };
export function newArray(length) {
    return Array.apply(null, Array(length));
}
export function pickTriggerPropsFromRest(rest) {
    return pick(rest, [
        'onMouseEnter',
        'onMouseLeave',
        'onMouseMove',
        'onContextMenu',
        'onClick',
        'onFocus',
        'onBlur',
        'tabIndex',
    ]);
}
export var VALIDATE_STATUS = {
    error: 'error',
    success: 'success',
    warning: 'warning',
    validating: 'validating',
};
